import React, { useState, useEffect } from "react";
import { LOCALE } from "../../properties/Locale";
import { Link, Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/appStyle";
import { useDispatch } from "react-redux";
import {
  changePageTitle,
  notifyShowSuccessMessage,
  triggerRerender,
} from "../../common/actions/CommonActions";
import {
  TextField,
  Grid,
  Paper,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  CircularProgress,
  DialogContent,
  Input,
  IconButton,
  Icon,
  Divider,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import EntityMetadata from "../../common/components/EntityMetadata";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { VacancyRepository } from "./VacancyRepository";
import CardBody from "../../common/components/Card/CardBody";
import Card from "../../common/components/Card/Card";
import CardHeader from "../../common/components/Card/CardHeader";
import { GradingSchemaRepository } from "../configuration/gradingSchema/GradingSchemaRepository";

const useStyles = makeStyles(styles);

export default function VacancyCreateComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [rerender, triggerRerenderLocal] = React.useState(false);
  const [vacancyData, setVacancyData] = React.useState({
    name: "",
    description: "",
    startDate: new Date(),
    endDate: new Date(),
    gradingSchema: { id: "" },
    vacancyType: "",
    commissionEvalStartDate: new Date(),
    commissionEvalEndDate: new Date(),
    bureauEvalStartDate: new Date(),
    bureauEvalEndDate: new Date(),
    eduCenterEvalStartDate: new Date(),
    eduCenterEvalEndDate: new Date(),
    schoolEvalStartDate: new Date(),
    schoolEvalEndDate: new Date(),
    minPointsTraining: 20,
    minPointsCommission: 45,
    maxPointsCommission: 80,
    maxPointsAdvisor: 80,
    maxPointsSchool: 20,
    maxPointsTotal: 180,
    minPointsRanglistCommission: 45,
    minPointsRanglistAdvisor: 45,
    minPointsRanglistSchool: 11,
  });
  const [redirectTo, setRedirectTo] = useState();
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(false);
  const [orderBy, setOrderBy] = useState("dateCreated");
  const [orderDirection, setOrderDirection] = useState("ASC");
  const [gradingSchemas, setGradingSchemas] = useState();

  const handleChange = (event, name) => {
    let data = vacancyData;
    data[name] = event.target.value;
    if (name === "vacancyType") {
      if (event.target.value.includes("MENTOR")) {
        data.minPointsTraining = 20;
        data.minPointsCommission = 45;
        data.maxPointsCommission = 80;
        data.maxPointsAdvisor = 80;
        data.maxPointsSchool = 20;
        data.maxPointsTotal = 180;
        data.minPointsRanglistCommission = 45;
        data.minPointsRanglistAdvisor = 45;
        data.minPointsRanglistSchool = 11;
      } else {
        data.minPointsTraining = 25;
        data.minPointsCommission = 60;
        data.maxPointsCommission = 100;
        data.maxPointsAdvisor = 100;
        data.maxPointsSchool = 25;
        data.maxPointsTotal = 225;
        data.minPointsRanglistCommission = 60;
        data.minPointsRanglistAdvisor = 60;
        data.minPointsRanglistSchool = 10;
      }
    }
    setVacancyData(data);
    triggerRerenderLocal(!rerender);
  };
  const handleChangeBoolean = (name, value) => {
    let data = vacancyData;
    data[name] = value;
    setVacancyData(data);
    triggerRerenderLocal(!rerender);
  };
  const handleChangeDate = (date, name) => {
    let data = vacancyData;
    data[name] = date;
    setVacancyData(data);
    triggerRerenderLocal(!rerender);
  };
  const handleChangeForm = (event, name) => {
    let data = vacancyData;
    data[name].form.id = event.target.value;
    setVacancyData(data);
    triggerRerenderLocal(!rerender);
  };

  const handleSubmit = () => {
    VacancyRepository.save(vacancyData).then(
      (res) => {
        setVacancyData({
          name: "",
          description: "",
          startDate: new Date(),
          endDate: new Date(),
          gradingSchema: { id: "" },
          vacancyType: "",
          commissionEvalStartDate: new Date(),
          commissionEvalEndDate: new Date(),
          bureauEvalStartDate: new Date(),
          bureauEvalEndDate: new Date(),
          eduCenterEvalStartDate: new Date(),
          eduCenterEvalEndDate: new Date(),
          schoolEvalStartDate: new Date(),
          schoolEvalEndDate: new Date(),
          minPointsTraining: 20,
          minPointsCommission: 45,
          maxPointsCommission: 80,
          maxPointsAdvisor: 80,
          maxPointsSchool: 20,
          maxPointsTotal: 180,
          minPointsRanglistCommission: 45,
          minPointsRanglistAdvisor: 45,
          minPointsRanglistSchool: 11,
        });
        dispatch(triggerRerender());
        dispatch(
          notifyShowSuccessMessage(LOCALE.vacancy_create_success_message)
        );
        setRedirectTo("/app/vacancy");
      },
      (err) => {}
    );
  };

  React.useEffect(() => {
    dispatch(changePageTitle(LOCALE.vacancy));
    GradingSchemaRepository.fetchAllGradingSchemas({
      page: 0,
      size: 100,
      orderBy: orderBy,
      orderDirection: orderDirection,
    }).then((res) => {
      setGradingSchemas(res.data.content);
    });
  }, []);

  const handleClose = () => {};

  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      <Card>
        <Dialog
          open={true}
          onClose={handleClose}
          maxWidth="md"
          fullWidth={true}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              overflowY: "unset",
            },
          }}
        >
          <CardHeader color="theme">
            <h4 className={classes.cardTitleWhite}>
              {`${LOCALE.create_new_vacancy}`}
              <Link to={`/app/vacancy`} style={{ textDecoration: "none" }}>
                <IconButton
                  style={{ float: "right", color: "white" }}
                  aria-label="close"
                >
                  <Icon>close</Icon>
                </IconButton>
              </Link>
            </h4>
          </CardHeader>
          <CardBody>
            <DialogContent>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    label={LOCALE.name}
                    variant="outlined"
                    value={vacancyData.name}
                    margin="dense"
                    size="small"
                    onChange={(e) => handleChange(e, "name")}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    label={LOCALE.description}
                    multiline={true}
                    rows={3}
                    margin="dense"
                    size="small"
                    variant="outlined"
                    value={vacancyData.description}
                    onChange={(e) => handleChange(e, "description")}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    size="small"
                    fullWidth
                    margin="dense"
                  >
                    <InputLabel id="demo-simple-select-label1">
                      Шема за оценување
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label1"
                      id="demo-simple-select1"
                      label="Шема за оценување"
                      margin="dense"
                      value={vacancyData.gradingSchema}
                      onChange={(e) => handleChange(e, "gradingSchema")}
                    >
                      {gradingSchemas?.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={5}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    size="small"
                    fullWidth
                    margin="dense"
                  >
                    <InputLabel id="demo-simple-select-label">
                      Тип на конкурс
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Тип на конкурс"
                      margin="dense"
                      value={vacancyData.vacancyType}
                      onChange={(e) => handleChange(e, "vacancyType")}
                    >
                      <MenuItem key="TEACHER_MENTOR" value="TEACHER_MENTOR">
                        Наставник-Ментор
                      </MenuItem>
                      <MenuItem key="TEACHER_ADVISOR" value="TEACHER_ADVISOR">
                        Наставник-Советник
                      </MenuItem>
                      <MenuItem key="ASSOCIATE_MENTOR" value="ASSOCIATE_MENTOR">
                        Стручен Соработник-Ментор
                      </MenuItem>
                      <MenuItem
                        key="ASSOCIATE_ADVISOR"
                        value="ASSOCIATE_ADVISOR"
                      >
                        Стручен Соработник-Советник
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        format="MM/dd/yyyy"
                        inputVariant="outlined"
                        margin="dense"
                        id="date-from"
                        label={LOCALE.startDate}
                        value={vacancyData.startDate}
                        onChange={(date) => handleChangeDate(date, "startDate")}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        format="MM/dd/yyyy"
                        margin="dense"
                        inputVariant="outlined"
                        id="date-to"
                        label={LOCALE.endDate}
                        value={vacancyData.endDate}
                        onChange={(date) => handleChangeDate(date, "endDate")}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10} style={{ textAlign: "center" }}>
                    {" "}
                    <Typography>{LOCALE.max_points}</Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.commission}
                      variant="outlined"
                      value={vacancyData.maxPointsCommission}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "maxPointsCommission")}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.advisor}
                      variant="outlined"
                      value={vacancyData.maxPointsAdvisor}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "maxPointsAdvisor")}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.school}
                      variant="outlined"
                      value={vacancyData.maxPointsSchool}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "maxPointsSchool")}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.total}
                      variant="outlined"
                      value={vacancyData.maxPointsTotal}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "maxPointsTotal")}
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>{" "}
              </div>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10} style={{ textAlign: "center" }}>
                    {" "}
                    <Typography>
                      {LOCALE.min_points_for_commision_eval}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.training}
                      variant="outlined"
                      value={vacancyData.minPointsTraining}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "minPointsTraining")}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.professional_development}
                      variant="outlined"
                      value={vacancyData.minPointsCommission}
                      margin="dense"
                      size="small"
                      onChange={(e) => handleChange(e, "minPointsCommission")}
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>{" "}
              </div>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10} style={{ textAlign: "center" }}>
                    {" "}
                    <Typography>{LOCALE.min_points_for_ranklist}</Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.commission}
                      variant="outlined"
                      value={vacancyData.minPointsRanglistCommission}
                      margin="dense"
                      size="small"
                      onChange={(e) =>
                        handleChange(e, "minPointsRanglistCommission")
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.advisor}
                      variant="outlined"
                      value={vacancyData.minPointsRanglistAdvisor}
                      margin="dense"
                      size="small"
                      onChange={(e) =>
                        handleChange(e, "minPointsRanglistAdvisor")
                      }
                    />
                  </Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      label={LOCALE.school}
                      variant="outlined"
                      value={vacancyData.minPointsRanglistSchool}
                      margin="dense"
                      size="small"
                      onChange={(e) =>
                        handleChange(e, "minPointsRanglistSchool")
                      }
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>{" "}
              </div>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.commission_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={vacancyData.commissionEvalStartDate}
                          onChange={(date) =>
                            handleChangeDate(date, "commissionEvalStartDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={vacancyData.commissionEvalEndDate}
                          onChange={(date) =>
                            handleChangeDate(date, "commissionEvalEndDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.bureau_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={vacancyData.bureauEvalStartDate}
                          onChange={(date) =>
                            handleChangeDate(date, "bureauEvalStartDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={vacancyData.bureauEvalEndDate}
                          onChange={(date) =>
                            handleChangeDate(date, "bureauEvalEndDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.eduCenter_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={vacancyData.eduCenterEvalStartDate}
                          onChange={(date) =>
                            handleChangeDate(date, "eduCenterEvalStartDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={vacancyData.eduCenterEvalEndDate}
                          onChange={(date) =>
                            handleChangeDate(date, "eduCenterEvalEndDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.school_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={vacancyData.schoolEvalStartDate}
                          onChange={(date) =>
                            handleChangeDate(date, "schoolEvalStartDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={vacancyData.schoolEvalEndDate}
                          onChange={(date) =>
                            handleChangeDate(date, "schoolEvalEndDate")
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={vacancyData.isCustom}
                          value={vacancyData.isCustom}
                          onChange={(e) =>
                            handleChangeBoolean("isCustom", e.target.checked)
                          }
                          name="Дали конкурсот се однесува на одредена листа на училишта?"
                        />
                      }
                      label="Дали конкурсот се однесува на одредена листа на училишта?"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <EntityMetadata data={vacancyData} />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Link to={`/app/vacancy`} style={{ textDecoration: "none" }}>
                <Button size="small" variant="outlined" color="secondary">
                  {LOCALE.close}
                </Button>
              </Link>
              <Button
                type="submit"
                size="small"
                variant="contained"
                color="primary"
                disabled={btnSubmitLoading}
                className={btnSubmitLoading ? "btn-loading" : ""}
                onClick={handleSubmit}
              >
                {LOCALE.save}
                {btnSubmitLoading && (
                  <CircularProgress
                    color="secondary"
                    size={20}
                    style={{ position: "absolute" }}
                  />
                )}
              </Button>
            </DialogActions>
          </CardBody>
        </Dialog>
      </Card>
    </div>
  );
}
